<template>
  <div class="flex flex-col leading-normal tracking-normal bg-white" id="main-body">
    <LayoutNavbar />

    <div class="w-full flex flex-col sm:flex-row flex-wrap sm:flex-nowrap grow h-full">
      <div class="w-fixed pr-5 flex-shrink flex-grow-0 px-4">
        <div class="sticky top-0 pl-4 pt-1 h-full">
          <LayoutSidebar />
        </div>
      </div>
      <main role="main" class="w-full flex-grow mt-2 px-3 h-full">
        <NoticeBarComponent />
        <RouterView />
      </main>
      <div class="w-auto min-w-auto min-h-full flex-col flex-auto px-2 justify-end lg:max-w-lg md:max-w-sm">
        <div class="flex flex-col px-2 mt-4">
          <ChatBoxComponent :is-clinician="undefined" :recipient-id="undefined" :visible="chatVisible" />
        </div>
      </div>
    </div>
    <footer class="hidden bg-black mt-auto text-white bottom-0 w-full md:block">
      <LayoutFooter />
    </footer>

  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import LayoutSidebar from '@/components/LayoutSidebar.vue'
import LayoutNavbar from '@/components/LayoutNavbar.vue'
import LayoutFooter from '@/components/LayoutFooter.vue'
import ChatBoxComponent from '@/components/ChatBoxComponent.vue'
import { useUserStore } from '@/stores/user'
import NoticeBarComponent from '@/components/NoticeBarComponent.vue'

let chatVisible = ref(false)

const userStore = useUserStore()
onMounted(async () => {
  const user = await userStore.getCurrentUser()
  if (user?.paid === true) {
    chatVisible.value = true
  }
})

// Use the stores
// const store = useSidebarStore()

// // Computed properties
// const sideBarOpen = computed(() => store.sidebar)

</script>